export default __webpack_public_path__ + "static/media/delete_3.a5746602.svg";